import {
  Component,
  OnInit,
  Output,
  ElementRef,
  PLATFORM_ID,
  Inject,
  ViewChild,
  ChangeDetectorRef,
  Renderer2,
} from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import {
  faLinkedinIn,
  faTwitter,
  faInstagram,
  faFacebookF,
} from "@fortawesome/free-brands-svg-icons";

import { IParametrosBackEnd } from "../../../interfaces/IParametrosBackEnd";
import { ModalLoginComponent } from "../../../components/modal-login/modal-login.component";
import { Title, Meta } from "@angular/platform-browser";
import { environment } from "../../../../environments/environment";
import { saveAs } from "file-saver";
import { NgxSpinnerService } from "ngx-spinner";
import { isPlatformBrowser, registerLocaleData } from "@angular/common";
import { CarrerjetService } from "src/app/services/carrerjet.service";
import localePt from "@angular/common/locales/pt";

registerLocaleData(localePt, "pt-BR");

@Component({
  selector: "app-vaga-detalhes",
  templateUrl: "./vaga-detalhes.component.html",
  styleUrls: ["./vaga-detalhes.component.css"],
})
export class VagaDetalhesComponent implements OnInit {
  linkedin = faLinkedinIn;
  facebook = faFacebookF;
  twitter = faTwitter;
  instagram = faInstagram;
  urlVaga: string = "";
  vagaId: string = "";
  redirect: string = "";
  origem: string = "";
  midiaCampanha: string = "";
  nomeCampanha: string = "";
  codigoVaga: number = 0;
  descricaoVagaGJ: string = "";
  empresa: string = "";
  titulo: string = "";
  cidade: string = "";
  estado: string = "";
  modalidade: string = "";
  linkSebrae: string = environment.serverUrl;

  vaga = {
    id: "",
    InternalId: "",
    EmpresaId: "",
    Status: "",
    CodigoVaga: "",
    Part: {
      nome: "",
      sigiloNomeEmpresa: false,
      cidade: {
        Cidade: "",
      },
      uf: "",
      cluster: {
        Descricao: "",
      },
      exibirSalario: false,
      salarioReal: "",
      escolaridade: {
        Descricao: "",
      },
      periodoTrabalho: {
        Descricao: "",
      },
      modeloContratacao: {
        Descricao: "",
      },
      descricaoVaga: "",
      requisitosObrigatorios: "",
      cronograma: [],
      horarioTrabalhoSemanaComeca: "",
      horarioTrabalhoSemanaTermina: "",
      NumeroEdital: "",
      NomeEdital: "",
      UrlEdital: "",
    },
    Empresa: {
      Caracteristica: {
        Nome: "",
        Descricao: "",
      },
    },
    Datas: {
      Publicacao: "",
      Cadastro: "",
    },
  };

  @ViewChild("Descricao") descricao: ElementRef;
  @ViewChild("RequisitosAcima") requisitosAcima: ElementRef;
  @ViewChild("RequisitosAbaixo") requisitosAbaixo: ElementRef;
  @ViewChild("DescricaoEmpresa") descricaoEmpresa: ElementRef;
  vagaCarregada: boolean = false;

  constructor(
    private router: Router,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private http: HttpClient,
    private modalService: NgbModal,
    private meta: Meta,
    @Inject(PLATFORM_ID) private readonly platformId: Object,
    private title: Title,
    private changeDetector: ChangeDetectorRef,
    private carrerjetService: CarrerjetService,
    private renderer: Renderer2
  ) {
    this.route.params.subscribe((res) => {
      //
      this.vagaId = res.idVaga;
      this.codigoVaga = res.codigo;
      this.empresa = res.empresa;
      this.titulo = res.titulo;
      this.cidade = res.ciadade;
      this.estado = res.estado;
      this.modalidade = res.modalidade;
      //
    });

    this.route.queryParams.subscribe((params) => {
      if ("vaga" in params) {
        this.vagaId = params["vaga"];
      }
      if ("redirect" in params) {
        this.redirect = params["redirect"];
      }
      if ("origem" in params) {
        this.origem = params["origem"];
      }
      if ("midiaCampanha" in params) {
        this.midiaCampanha = params["midiaCampanha"];
      }
      if ("nomeCampanha" in params) {
        this.nomeCampanha = params["nomeCampanha"];
      }
    });
  }

  ngOnInit(): void {
    this.spinner.show();
    this.carregarVaga();
  }

  isVagaRedeTeia(vaga: any) {
    console.log(vaga);
    if (
      vaga &&
      vaga.Part &&
      (vaga.Part.cidade === "Aparecida de Goiânia" ||
        vaga.Part.cidade === "Anápolis" ||
        vaga.Part.cidade === "Goiânia" ||
        vaga.Part.cidade === "Rio Verde" ||
        vaga.Part.cidade === "São Paulo" ||
        vaga.Part.cidade === "Senador Canedo" ||
        vaga.Part.cidade === "Manaus") &&
      vaga.EmpresaId === "1f7048e2-b768-4fb6-8ae9-b85ed02ad199"
    ) {
      return true;
    }
    return false;
  }

  isEmpresaCBLLitio() {
    if (this.vaga.EmpresaId === "e9c3dd96-b23a-410f-829a-522015963c78") {
      return true;
    }
    return false;
  }

  isValidData(value: any): boolean {
    return (
      value &&
      typeof value === "string" &&
      value.trim() !== "" &&
      value.trim() !== "Invalid Date Inval" &&
      value.trim() !== "NaN/NaN/NaN NaN:NaN"
    );
  }

  criarScriptLocalidade(data: any) {
    const script = this.renderer.createElement("script");
    script.type = "application/ld+json";

    const jsonLd = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      name: "Reachr",
      image:
        "https://www.reachr.com.br/wp-content/uploads/2022/09/Logo-Reachr-%E2%80%93-Branco.png",
      "@id": "https://reachr.com.br",
      url: "https://reachr.com.br",
      address: {
        "@type": "PostalAddress",
        addressLocality: data?.Part?.cidade?.Cidade,
        addressRegion: data?.Part?.cidade?.UF,
        addressCountry: "BR",
      },
      openingHoursSpecification: [
        {
          "@type": "OpeningHoursSpecification",
          dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
          opens: "09:00",
          closes: "18:00",
        },
      ],
      sameAs: [
        "https://www.linkedin.com/company/reachr-recrutamento/",
        "https://www.instagram.com/reachr.ai",
      ],
    };

    script.textContent = JSON.stringify(jsonLd);
    this.renderer.appendChild(document.head, script);
  }

  getEmpresaLogo(vaga: any) {
    return vaga.Empresa?.Caracteristica?.Logo?.replace("http", "https");
    // if (vaga.EmpresaId === "a4bc0b60-42fb-42f6-8d00-6bc381bb490c") {
    //   return "assets/img/logo-sulnorte.png";
    // } else {
    // }
  }

  carregarVaga() {
    const headers = new HttpHeaders().set("Content-Type", "application/json");

    if (this.vagaCarregada == true) {
      return;
    }

    this.vagaCarregada = true;

    if (this.codigoVaga) {
      this.http
        .get(
          environment.serverApi +
            "/VagaParts/CodigoVaga/" +
            this.codigoVaga +
            "?v=" +
            new Date().getTime(),
          { headers: headers }
        )
        .subscribe(
          (data: any) => {
            this.isVagaRedeTeia(data);
            this.criarScriptLocalidade(data);
            this.spinner.hide();
            if (data.id) {
              this.vagaId = data.InternalId;

              this.vaga = JSON.parse(JSON.stringify(data));
              //
              if (
                this.vaga.Part.horarioTrabalhoSemanaComeca !=
                  "Invalid Date Inval" &&
                this.vaga.Part.horarioTrabalhoSemanaComeca != null &&
                this.vaga.Part.horarioTrabalhoSemanaComeca !=
                  "NaN/NaN/NaN NaN:NaN" &&
                this.vaga.Part.horarioTrabalhoSemanaComeca != "" &&
                this.vaga.Part.horarioTrabalhoSemanaComeca != "31/12/1969 21:00"
              ) {
                this.vaga.Part.horarioTrabalhoSemanaComeca =
                  this.vaga.Part.horarioTrabalhoSemanaComeca.slice(-5);
              } else {
                this.vaga.Part.horarioTrabalhoSemanaComeca = null;
              }
              //

              if (
                this.vaga.Part.horarioTrabalhoSemanaTermina !=
                  "Invalid Date Inval" &&
                this.vaga.Part.horarioTrabalhoSemanaTermina != null &&
                this.vaga.Part.horarioTrabalhoSemanaTermina !=
                  "NaN/NaN/NaN NaN:NaN" &&
                this.vaga.Part.horarioTrabalhoSemanaTermina != "" &&
                this.vaga.Part.horarioTrabalhoSemanaTermina !=
                  "31/12/1969 21:00"
              ) {
                this.vaga.Part.horarioTrabalhoSemanaTermina =
                  this.vaga.Part.horarioTrabalhoSemanaTermina.slice(-5);
              } else {
                this.vaga.Part.horarioTrabalhoSemanaTermina = null;
              }
              //

              this.changeDetector.detectChanges();

              if (this.vaga.Part.cronograma != null) {
                this.vaga.Part.cronograma = this.vaga.Part.cronograma.sort(
                  (a, b) => {
                    if (a.ordem > b.ordem) {
                      return 1;
                    }
                    if (a.ordem < b.ordem) {
                      return -1;
                    }
                    return 0;
                  }
                );
              }

              if (this.vaga.Datas.Publicacao.substr(-1).toLowerCase() == "z") {
                this.vaga.Datas.Publicacao = this.vaga.Datas.Publicacao.slice(
                  0,
                  -1
                );
              }
              //

              if (
                !this.vaga.Part.sigiloNomeEmpresa &&
                this.vaga.Empresa.Caracteristica.Descricao
              ) {
                this.descricaoEmpresa.nativeElement.innerHTML =
                  this.vaga.Empresa.Caracteristica.Descricao;
              }
              if (this.vaga.Part.descricaoVaga) {
                this.descricao.nativeElement.innerHTML =
                  this.vaga.Part.descricaoVaga;
              }
              if (this.vaga.Part.requisitosObrigatorios) {
                this.requisitosAbaixo.nativeElement.innerHTML =
                  this.vaga.Part.requisitosObrigatorios;
              }
              this.googleJobs(this.vaga);
            } else {
              this.spinner.hide();
              this.router.navigate(["/vaga-nao-encontrada"]);
              return;
            }
          },
          (error) => {
            this.spinner.hide();

            this.router.navigate(["/vaga-nao-encontrada"]);
            return;
          }
        );
    } else if (this.vagaId == "costureira") {
      this.codigoVaga = 10282;
      this.http
        .get(
          environment.serverApi +
            "/VagaParts/CodigoVaga/" +
            this.codigoVaga +
            "?v=" +
            new Date().getTime(),
          { headers: headers }
        )
        .subscribe((data) => {
          this.spinner.hide();
          this.vaga = JSON.parse(JSON.stringify(data));
          if (this.vaga.Datas.Publicacao.substr(-1).toLowerCase() == "z") {
            this.vaga.Datas.Publicacao = this.vaga.Datas.Publicacao.slice(
              0,
              -1
            );
          }

          if (
            !this.vaga.Part.sigiloNomeEmpresa &&
            this.vaga.Empresa.Caracteristica.Descricao
          ) {
            this.descricaoEmpresa.nativeElement.innerHTML =
              this.vaga.Empresa.Caracteristica.Descricao;
          }
          if (this.vaga.Part.descricaoVaga) {
            this.descricao.nativeElement.innerHTML =
              this.vaga.Part.descricaoVaga;
          }
          if (this.vaga.Part.requisitosObrigatorios) {
            this.requisitosAbaixo.nativeElement.innerHTML =
              this.vaga.Part.requisitosObrigatorios;
          }

          if (
            !this.vaga.Part.sigiloNomeEmpresa &&
            this.vaga.Empresa.Caracteristica.Descricao
          ) {
            this.descricaoEmpresa.nativeElement.innerHTML =
              this.vaga.Empresa.Caracteristica.Descricao;
          }
          if (this.vaga.Part.descricaoVaga) {
            this.descricao.nativeElement.innerHTML =
              this.vaga.Part.descricaoVaga;
          }
          if (this.vaga.Part.requisitosObrigatorios) {
            this.requisitosAbaixo.nativeElement.innerHTML =
              this.vaga.Part.requisitosObrigatorios;
          }
          //
          this.googleJobs(this.vaga);
          this.vagaId = this.vaga.InternalId;
        });
    } else {
      this.http
        .get(
          environment.serverApi +
            "/VagaParts/Vaga/" +
            this.vagaId +
            "?v=" +
            new Date().getTime(),
          { headers: headers }
        )
        .subscribe(
          (data: any) => {
            this.spinner.hide();
            if (data.id) {
              this.vaga = JSON.parse(JSON.stringify(data));
              if (this.vaga.Datas.Publicacao.substr(-1).toLowerCase() == "z") {
                this.vaga.Datas.Publicacao = this.vaga.Datas.Publicacao.slice(
                  0,
                  -1
                );
              }

              if (
                !this.vaga.Part.sigiloNomeEmpresa &&
                this.vaga.Empresa.Caracteristica.Descricao
              ) {
                this.descricaoEmpresa.nativeElement.innerHTML =
                  this.vaga.Empresa.Caracteristica.Descricao;
              }
              if (this.vaga.Part.descricaoVaga) {
                this.descricao.nativeElement.innerHTML =
                  this.vaga.Part.descricaoVaga;
              }
              if (this.vaga.Part.requisitosObrigatorios) {
                this.requisitosAbaixo.nativeElement.innerHTML =
                  this.vaga.Part.requisitosObrigatorios;
              }
              //
              this.googleJobs(this.vaga);
            } else {
              this.spinner.hide();
              this.router.navigate(["/vaga-nao-encontrada"]);
              return;
            }
          },
          (error) => {
            this.spinner.hide();

            this.router.navigate(["/vaga-nao-encontrada"]);
            return;
          }
        );
    }
  }

  openModalLogin() {
    const parametros = this.getParametros();
    const modalRef = this.modalService.open(ModalLoginComponent);
    // envia os parametros para carregar no modal pelo @Input parametros
    modalRef.componentInstance.parametros = parametros;
    modalRef.componentInstance.empresaId = this.vaga.EmpresaId;
  }

  getParametros(): IParametrosBackEnd {
    return {
      vagaId: this.vagaId,
      redirect: this.redirect,
      origem: this.origem,
      midiaCampanha: this.midiaCampanha,
      nomeCampanha: this.nomeCampanha,
    };
  }

  todasVagas() {
    this.router.navigate(["/vagas"], { relativeTo: this.route });
  }

  todasVagasEmpresa(empresa) {
    //
    this.router.navigate(["/vagas", empresa]);
  }

  empresaSebrae() {
    if (
      this.vaga.Part.cronograma != null &&
      this.vaga.Part.cronograma.length > 0
    ) {
      return true;
    } else {
      return false;
    }
  }

  vagaAgir() {
    if (
      this.vaga.EmpresaId == "1f7048e2-b768-4fb6-8ae9-b85ed02ad199" &&
      this.vaga.Part.NumeroEdital &&
      this.vaga.Part.NomeEdital &&
      this.vaga.Part.UrlEdital
    ) {
      return true;
    } else {
      return false;
    }
  }

  vagaSebrae() {
    if (this.vaga.EmpresaId == "62648712-1e97-4d76-bfbc-0bf175cb44e6") {
      if (this.vaga.InternalId == "cb9f8f2e-ca6f-4593-a18d-e2eb239e4b02") {
        this.linkSebrae =
          environment.serverUrl +
          "/vaga/documentos/comunicao-analista-tecnico-I-atendimento-cidade-tubarao.pdf";
        return true;
      } else if (
        this.vaga.InternalId == "fe2facb5-87a2-459d-9af7-2645d8dde539"
      ) {
        this.linkSebrae =
          environment.serverUrl +
          "/vaga/documentos/comunicado-analista-tecnico-II-analista-de-atendimento-florianopolis.pdf";
        return true;
      } else if (
        this.vaga.InternalId == "684266cb-f5a7-440c-8e33-930fa08aff34"
      ) {
        this.linkSebrae =
          environment.serverUrl +
          "/vaga/documentos/comunicado-analista-tecnico-ii-marketing-digital.pdf";
        return true;
      } else if (
        this.vaga.InternalId == "8c32fadf-c524-4292-ba8f-96a689358fb7"
      ) {
        this.linkSebrae =
          environment.serverUrl +
          "/vaga/documentos/comunicado-contabilidade.pdf";
        return true;
      } else if (
        this.vaga.InternalId == "71cab8cf-fd9d-4142-9a94-cf4716cffa77"
      ) {
        this.linkSebrae =
          environment.serverUrl + "/vaga/documentos/comunicado-projetos.pdf";
        return true;
      } else if (
        this.vaga.InternalId == "b2d36528-ba04-4dbc-a0d2-f543cc78e471"
      ) {
        this.linkSebrae =
          environment.serverUrl +
          "/vaga/documentos/comunicado-analista-I-gestao-de-contratos.pdf";
        return true;
      } else if (
        this.vaga.InternalId == "6f01a1db-bb67-4be3-84af-96f3f28461af"
      ) {
        this.linkSebrae =
          environment.serverUrl +
          "/vaga/documentos/comunicado-analista-I-projetos-e-negocios.pdf";
        return true;
      } else if (
        this.vaga.InternalId == "2e797c14-b25b-4eac-a1f8-8727e9daeba4"
      ) {
        this.linkSebrae =
          environment.serverUrl +
          "/vaga/documentos/comunicado-Analista-II-articulacao-de-negocios.pdf";
        return true;
      } else if (
        this.vaga.InternalId == "fdc9ab04-6694-4dae-87fd-c98715c97c30"
      ) {
        this.linkSebrae =
          environment.serverUrl +
          "/vaga/documentos/comunicado-analista-tec-I-advogado.pdf";
        return true;
      } else if (
        this.vaga.InternalId == "6d1f6b46-a0d3-4752-8db7-051cae7eb9e3"
      ) {
        this.linkSebrae =
          environment.serverUrl +
          "/vaga/documentos/comunicado-analista-II-missoes-internacionais.pdf";
        return true;
      } else if (
        this.vaga.InternalId == "4f8050b9-a359-42df-9775-0591b86f6fc8"
      ) {
        this.linkSebrae =
          environment.serverUrl +
          "/vaga/documentos/comunicado-analista-I-projetos-setoriais.pdf";
        return true;
      } else if (
        this.vaga.InternalId == "7502747e-10e8-420c-b5b4-4eda610b4e81"
      ) {
        this.linkSebrae =
          environment.serverUrl +
          "/vaga/documentos/comunicado-analista-tecnico-I-recursos-humanos-bp-alt.pdf";
        return true;
      } else if (
        this.vaga.InternalId == "a2e0722a-38d4-49fe-9bb7-b5ec4fa0e6f5"
      ) {
        this.linkSebrae =
          environment.serverUrl +
          "/vaga/documentos/comunicado-analista-tecnico-II-analista-de-dados.pdf";
        return true;
      } else if (
        this.vaga.InternalId == "c348077a-ee72-4b70-9430-ec5ef809e7bc"
      ) {
        this.linkSebrae =
          environment.serverUrl +
          "/vaga/documentos/comunicado-analista-tecnico-I-recursos-humanos-bp-exclusiva-pcd.pdf";
        return true;
      } else if (
        this.vaga.InternalId == "d21a0bf9-2ff7-4850-84f5-b724e56a6d8f"
      ) {
        this.linkSebrae =
          environment.serverUrl +
          "/vaga/documentos/comunicado-assistente-administrativo-II-secretaria.pdf";
        return true;
      } else if (
        this.vaga.InternalId == "4dc9d939-a947-46a9-9f75-6fd891491b09"
      ) {
        this.linkSebrae =
          environment.serverUrl +
          "/vaga/documentos/comunicado-analista-tecnico-I-negocios-vaga-interna.pdf";
        return true;
      } else if (
        this.vaga.InternalId == "4a9aa1ec-e860-44c2-9648-dd7e9a8dd080"
      ) {
        this.linkSebrae =
          environment.serverUrl +
          "/vaga/documentos/comunicado-analista-tecnico-I-projetos-empreendedorismo-feminino-PCD.pdf";
        return true;
      } else if (
        this.vaga.InternalId == "0ce7b352-880c-4616-9a41-b22bcc512ecc"
      ) {
        this.linkSebrae =
          environment.serverUrl +
          "/vaga/documentos/comunicado-analista-tecnico-I-negocios.pdf";
        return true;
      } else if (
        this.vaga.InternalId == "0828ea3b-7971-4bec-b865-b19b7eac41ff"
      ) {
        this.linkSebrae =
          environment.serverUrl +
          "/vaga/documentos/comunicado-analista-tecnico-I-projetos-empreendedorismo-feminino.pdf";
        return true;
      } else if (
        this.vaga.InternalId == "abb08509-a649-4a71-b990-cb1c430123d6"
      ) {
        this.linkSebrae =
          environment.serverUrl +
          "/vaga/documentos/comunicado-analista-tecnico-II-inovacoes-e-startups.pdf";
        return true;
      } else if (
        this.vaga.InternalId == "c502b46e-2ccd-444c-9fe1-c72c5d0fa211"
      ) {
        this.linkSebrae =
          environment.serverUrl +
          "/vaga/documentos/comunicado-analista-tecnico-I–gestao-de-eventos.pdf";
        return true;
      } else if (
        this.vaga.InternalId == "84951f66-66d7-4cfe-974d-a46d6ab681bf"
      ) {
        this.linkSebrae =
          environment.serverUrl +
          "/vaga/documentos/comunicado-assistente-administrativo-II-exclusiva-pcd.pdf";
        return true;
      } else if (
        this.vaga.InternalId == "508d864f-fa65-48e0-b48b-ddd336ac94a6"
      ) {
        this.linkSebrae =
          environment.serverUrl +
          "/vaga/documentos/comunicado-analista-tecnico-II–estrategia-desenvolvimento-de-negocios.pdf";
        return true;
      } else if (
        this.vaga.InternalId == "d3b488eb-7533-49d1-b4ad-3d06103a55ca"
      ) {
        this.linkSebrae =
          environment.serverUrl +
          "/vaga/documentos/comunicado-AT I-orcamento-e-planejamento-estrategico.pdf";
        return true;
      } else if (
        this.vaga.InternalId == "f574264c-91ee-4736-b8db-d4b41ad6968d"
      ) {
        this.linkSebrae =
          environment.serverUrl +
          "/vaga/documentos/comunicado-analista-tecnico-II-secretaria.pdf";
        return true;
      } else if (
        this.vaga.InternalId == "6533e5d8-116c-4768-ba95-71e72656debc"
      ) {
        this.linkSebrae =
          environment.serverUrl +
          "/vaga/documentos/comunicado-analista-tecnico-II-processos.pdf";
        return true;
      } else if (
        this.vaga.InternalId == "17cb849a-cb66-415b-84fc-c46c14577df4"
      ) {
        this.linkSebrae =
          environment.serverUrl +
          "/vaga/documentos/comunicado-analista-I-negocios-florianopolis-e-sao-jose.pdf";
        return true;
      } else if (
        this.vaga.InternalId == "08546b86-ff2a-4676-9b57-338efa41b44c"
      ) {
        this.linkSebrae =
          environment.serverUrl +
          "/vaga/documentos/comunicado-at-I-negocios-chapeco.pdf";
        return true;
      } else if (
        this.vaga.InternalId == "e4f8d652-c727-4496-8ed4-b342049437ef"
      ) {
        this.linkSebrae =
          environment.serverUrl +
          "/vaga/documentos/comunicado-at-II-projetos-e-negocios.pdf";
        return true;
      } else if (
        this.vaga.InternalId == "482c210d-3bfa-471d-95a5-2b9274e2478f"
      ) {
        this.linkSebrae =
          environment.serverUrl +
          "/vaga/documentos/comunicado-analista-tecnico-I-analista-de-negocios.pdf";
        return true;
      } else if (
        this.vaga.InternalId == "e87a0170-c3eb-41c2-99d1-bdedc2681fdb"
      ) {
        this.linkSebrae =
          environment.serverUrl +
          "/vaga/documentos/comunicado-at-I-negocios-lages.pdf";
        return true;
      } else if (
        this.vaga.InternalId == "9b0f5ac2-3ef0-44ff-bef2-faf9161656df"
      ) {
        this.linkSebrae =
          environment.serverUrl +
          "/vaga/documentos/comunicado-AT-I-contratos.pdf";
        return true;
      } else if (
        this.vaga.InternalId == "7cf6711a-6fa9-4116-9951-c6f6bc8470d1"
      ) {
        this.linkSebrae =
          environment.serverUrl +
          "/vaga/documentos/comunicado-ATI-negocios-lages.pdf";
        return true;
      } else if (
        this.vaga.InternalId == "da37bb5f-0758-4506-8aa2-0ff517717c81"
      ) {
        this.linkSebrae =
          environment.serverUrl +
          "/vaga/documentos/comunicado-assistente-administrativo-II-itajai.pdf";
        return true;
      } else if (
        this.vaga.InternalId == "2223baa5-d188-4189-9c8f-e53bf2b4fa26"
      ) {
        this.linkSebrae =
          environment.serverUrl +
          "/vaga/documentos/comunicado-assistente-administrativo-II-joinville.pdf";
        return true;
      }
    } else {
      return false;
    }
  }

  downloadComunicado() {
    //application/octet-stream

    const requestOptions: any = {
      headers: new HttpHeaders({
        "Content-Type": "application/octet-stream",
      }),
      responseType: "blob",
    };

    const slug = "Comunicado - " + this.vaga.Part.nome;

    return this.http.get(this.linkSebrae, requestOptions).subscribe(
      (data) => {
        const blob = new Blob([data], { type: "application/pdf" });
        saveAs(blob, slug);
      },
      (err) => {}
    );
  }

  googleJobs(vaga: any) {
    this.urlVaga = window.location.href;

    if (isPlatformBrowser(this.platformId)) {
      const rawDataAbertura = this.dataAbertura(vaga);
      const rawDataFechamento = this.dataFechamento(vaga);

      const dataPostagem = rawDataAbertura?.substring(0, 10);

      let dataFechamento: string;
      if (
        !rawDataFechamento ||
        rawDataFechamento.startsWith("1970") ||
        rawDataFechamento === "0000-00-00"
      ) {
        // Adiciona 3 meses à data de abertura
        const aberturaDate = new Date(dataPostagem);
        aberturaDate.setMonth(aberturaDate.getMonth() + 3);
        dataFechamento = aberturaDate.toISOString().substring(0, 10);
      } else {
        dataFechamento = rawDataFechamento.substring(0, 10);
      }

      // Remover tags HTML e &nbsp; da descrição
      const descricaoTexto = this.descricaoVaga(vaga)
        ?.replace(/<[^>]+>/g, "") // Remove tags HTML
        .replace(/&nbsp;/g, " ") // Remove todas as ocorrências de &nbsp;
        .replace(/\s+/g, " ") // Remove espaços extras
        .trim(); // Remove espaços no início e no final

      // Criar o script de dados estruturados JSON-LD
      const script = document.createElement("script");
      script.setAttribute("type", "application/ld+json");

      const jsonLd = {
        "@context": "http://schema.org",
        "@type": "JobPosting",
        title: vaga?.Part?.nome || "", // Título da vaga
        datePosted: dataPostagem, // Data de postagem
        validThrough: dataFechamento, // Data de fechamento (3 meses após a abertura ou data fornecida)
        description: descricaoTexto, // Descrição sem tags HTML e &nbsp;
        employmentType: "FULL_TIME", // Tipo de emprego
        hiringOrganization: {
          "@type": "Organization",
          name: vaga?.Empresa?.Caracteristica?.Nome || "", // Nome da empresa
          sameAs: this.urlVaga.replace("localhost:4200", "www.reachr.com.br"), // URL da vaga
          logo: vaga?.Empresa?.Caracteristica?.Logo || "", // Logo da empresa
        },
        jobLocation: {
          "@type": "Place",
          address: {
            "@type": "PostalAddress",
            addressLocality: vaga?.Part?.cidade?.Cidade || "", // Cidade
            addressRegion: vaga?.Part?.cidade?.UF || "", // Estado
            addressCountry: "BR", // País
          },
        },
      };

      // Converter o objeto para string JSON e adicionar o script no corpo do documento
      script.textContent = JSON.stringify(jsonLd);
      document.body.appendChild(script);
    }
  }

  dataAbertura(vaga) {
    if (vaga.Datas.Publicacao) return vaga.Datas.Publicacao;
    if (vaga.Datas.Cadastro) return vaga.Datas.Cadastro;
    if (vaga.Part.dataPublicacao) return vaga.Part.dataPublicacao;
  }
  dataFechamento(vaga) {
    if (vaga.Datas.Fechamento) return vaga.Datas.Fechamento;
    if (vaga.Part.dataFechamento) return vaga.Part.dataFechamento;
    return "2030-01-01";
  }
  descricaoVaga(vaga) {
    let descricao = "";
    descricao = vaga.Part.descricaoVaga.replace("\n", "</p><p>");
    descricao = "<h2>Descrição: </h2><p>" + descricao + "</p>";
    if (vaga.Part.requisitosObrigatorios) return descricao;
    return (
      descricao +
      "<p>Requisitos desejados: " +
      vaga.Part.requisitosObrigatorios.replace("\n", "</p><p>") +
      "</p>"
    );
  }
}
